import script from "./ScrollVideoBlocks.vue?vue&type=script&setup=true&lang=js"
export * from "./ScrollVideoBlocks.vue?vue&type=script&setup=true&lang=js"

import "./ScrollVideoBlocks.vue?vue&type=style&index=0&id=4a3e343b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a3e343b"]])

export default __exports__